import { render } from "./MenuSidebarClient.vue?vue&type=template&id=0c6fda63&scoped=true"
import script from "./MenuSidebarClient.vue?vue&type=script&lang=js"
export * from "./MenuSidebarClient.vue?vue&type=script&lang=js"

import "./MenuSidebarClient.vue?vue&type=style&index=0&id=0c6fda63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6fda63"]])

export default __exports__